import { render, staticRenderFns } from "./return-details.vue?vue&type=template&id=b6318174&scoped=true"
import script from "./return-details.vue?vue&type=script&lang=js"
export * from "./return-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6318174",
  null
  
)

export default component.exports